<template>
  <div class="home" v-loading="loading">
    <div class="header">
      <!-- 搜索区域 -->
      <div class="search">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column label="电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="邮箱">
            <template slot-scope="scope">
              <span>{{ scope.row.email }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="198">
            <template slot-scope="scope">
              <div class="table-operation" @click="compileBtn(scope.row)">
                编辑
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--第二区域编辑 弹出框-->
    <div class="addBlock">
      <el-dialog
        :visible.sync="compileDialogVisible"
        width="444px"
        style="margin-top: 10vh"
        @close="addClose"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addBlock-div">
            <div class="addBlock-div-top">
              <div class="addBlock-div-top-title">编辑</div>
              <img
                class="addBlock-div-top-close"
                src="../../assets/common/close.png"
                @click="addClose"
              />
            </div>

            <div class="addBlock-div-center">
              <div class="center-conversion">
                <div class="conversion-title">电话</div>
                <div class="conversion-input">
                  <el-input
                    placeholder="输入电话号码"
                    v-model="compilePhone"
                    clearable
                  ></el-input>
                </div>
              </div>

              <div class="center-conversion">
                <div class="conversion-title">邮箱</div>
                <div class="conversion-input">
                  <el-input
                    placeholder="输入邮箱"
                    v-model="compileEmail"
                    clearable
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="addBlock-div-button">
              <!-- <div class="addBlock-div-button-left" @click="addClose">
                重 置
              </div> -->
              <div class="addBlock-div-button-right" @click="addConfirm">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getrelationDetail, postrelationAdd } from '../../api/common'

export default {
  comments() {},
  data() {
    return {
      // 编辑 弹出框  是否开启
      compileDialogVisible: false,
      // 编辑 弹出框  手机号
      compilePhone: '',
      // 编辑 弹出框  邮箱
      compileEmail: '',

      /* end */
      tableData: [],
      // 刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      basicFunShow: false,
    }
  },
  created() {
    // 获取关于我们详情
    this.loading = true
    this.getRelation()

    setTimeout(() => {
        this.basicFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取关于我们详情
    getRelation() {
      let params = {}

      getrelationDetail(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取数据
          this.tableData = []
          this.tableData.push(res.resultData)
          this.loading = false
        }
      })
    },
    // 编辑弹出框
    compileBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      this.compilePhone = item.phone
      this.compileEmail = item.email
      this.compileDialogVisible = true
    },
    // 添加按钮 蒙层  重置
    addClose() {
      this.compilePhone = ''
      this.compileEmail = ''
      this.compileDialogVisible = false
    },

    // 添加按钮 确认
    addConfirm() {
      let params = {
        phone: this.compilePhone,
        email: this.compileEmail,
      }

      postrelationAdd(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '添加成功！',
            type: 'success',
          })
          this.loading = true
          this.compileDialogVisible = false
          this.getRelation()
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.home {
  margin: 0 auto;
  background-color: #f4f5f9;
}
.header {
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
}
.search {
  padding: 24px;
  box-sizing: border-box;

  /deep/ .el-table thead {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: #d8d8d8;
  }

  /deep/ .el-table .el-table__cell {
    vertical-align: top;
  }

  /deep/ .el-table tr {
    height: 46px;
  }

  /deep/ .el-table__empty-text {
    line-height: 0;
  }

  .table-operation {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2aa4ff;
    text-decoration: underline;
  }
}
/* 添加弹出框 */
.addBlock {
  /deep/ .el-dialog__footer {
    padding: 0;
    text-align: left;
  }

  /deep/ .el-dialog {
    height: 280px;
    border-radius: 10px !important;
  }
  .addBlock-div {
    .addBlock-div-top {
      display: flex;
      height: 56px;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      box-sizing: border-box;
      border-bottom: 1px solid #e9edf4;
      .addBlock-div-top-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }
      .addBlock-div-top-close {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
    }

    .addBlock-div-center {
      padding: 20px 24px 0;
      box-sizing: border-box;

      .center-conversion {
        .conversion-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .conversion-input {
          margin-top: 4px;
          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }
      }

      .center-conversion:nth-child(2) {
        margin-top: 14px;
      }
    }

    .addBlock-div-button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;
      box-sizing: border-box;
      height: 52px;
      border-top: 1px solid #e9edf4;
      margin-top: 30px;

      .addBlock-div-button-left,
      .addBlock-div-button-right {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .addBlock-div-button-right {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        margin-left: 8px;
        color: #ffffff;
      }
    }
  }
}
</style>
